import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledButton } from '../../../atoms/Button/StyledButton';
import { StyledButtonsWrapper } from '../../../atoms/Payments/StyledButtonsWrapper';
import { StyledUPopupCloseButton } from '../../../atoms/Payments/StyledUPopupCloseButton';

import PaymentsPopup from '../../Payments/PaymentsPopup';

const DeleteManagerHourPopup = ({
    confirmPopup,
    setConfirmPopup,
    handleDelete,
    hour,
    deleteHour,
    getString,
}) => {
    if (!confirmPopup) return null;
    return (
        <PaymentsPopup>
            <div
                style={{
                    widht: '100%',
                    height: '100%',
                    paddingBottom: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flex: 1,
                }}
            >
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredpadding="50px 20px 50px 20px"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {getString('summary_edit_element_czy_na_pewno')}
                </StyledText>
                <StyledButtonsWrapper>
                    <StyledButton
                        onClick={() =>
                            handleDelete(hour.id, deleteHour, confirmPopup, setConfirmPopup)
                        }
                    >
                        {getString('addition_data_element_usun')}
                    </StyledButton>
                    <StyledUPopupCloseButton onClick={() => setConfirmPopup(false)}>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredtextalign="center"
                            hasdeclaredfontweight="700"
                            hasdeclaredfontcolor="#fff"
                            hascursor="pointer"
                        >
                            {getString('payments_paymentsPopup_zamknij')}
                        </StyledText>
                    </StyledUPopupCloseButton>
                </StyledButtonsWrapper>
            </div>
        </PaymentsPopup>
    );
};

export default DeleteManagerHourPopup;
